var map = {
	"./article.svg": "9cc7",
	"./event.svg": "3442",
	"./headphone.svg": "80ea",
	"./play.svg": "6476",
	"./project.svg": "a9cb",
	"./soft.svg": "2746",
	"./tech.svg": "9e95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "069f";